import axios from "axios";
import estadistics_1 from "../../models/gestionTiempos/estadistics/estadistics_1";
import estadistics_2 from "../../models/gestionTiempos/estadistics/estadistics_2";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getEstadistic1 = (customDate = null) => {
    const url = this.config.apiUrl;
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");

    const dateValue =
      customDate ||
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);

    const dateParam = `date_from=${dateValue}`;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/estadisticas1/${operId}?${dateParam}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return estadistics_1.fromJson(item);
        })
      );
  };

  getEstadistic2 = (customDate = null) => {
    const url = this.config.apiUrl;
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");

    const dateValue =
      customDate ||
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);

    const dateParam = `date_from=${dateValue}`;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/estadisticas2/${operId}?${dateParam}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return estadistics_2.fromJson(item);
        })
      );
  };
}

export default service;
